// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-schedule-carousel:not(.student-schedule__track) {
  padding: 5vh 17vw 2vh;
  max-width: 100%;
}

/* Student landing: carousel sits inside the schedule section track */
.student-schedule__track .slick-list {
  margin: 0 -6px;
  padding: 8px 0 6px;
}

.student-schedule__track .slick-slide {
  padding: 0 0 10px;
  box-sizing: border-box;
}

.home-schedule-carousel .slick-list {
  margin: 0 -12px;
  padding: 6px 0 4px;
}

.home-schedule-carousel .slick-track {
  display: flex !important;
  align-items: stretch;
}

.home-schedule-carousel .slick-slide {
  height: auto;
  display: flex;
}

.home-schedule-carousel .slick-slide > div {
  display: flex;
  width: 100%;
  height: 100%;
}

.home-schedule-slide {
  outline: none;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0 12px 8px;
  box-sizing: border-box;
}

.home-schedule-slide__panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 80vh;
  padding: 22px;
  border-radius: 22px;
  background: #ffffff;
  border: 1px solid #eceaf1;
  box-shadow: 0 8px 24px rgba(48, 45, 69, 0.08);
  box-sizing: border-box;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  overflow: hidden;
}

.home-schedule-slide:hover .home-schedule-slide__panel {
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(48, 45, 69, 0.12);
}

.home-schedule-slide__header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f0edf4;
  flex-shrink: 0;
}

/* Size/shape come from TeacherPhoto (.teacher-photo--circle); keep hook for layout */
.home-schedule-slide__photo {
  flex-shrink: 0;
}

.home-schedule-slide__identity {
  min-width: 0;
}

.home-schedule-slide__name {
  margin: 0;
  font-size: clamp(1.05rem, 2.2vw, 1.25rem);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #1f1b2e;
  line-height: 1.2;
}

.home-schedule-slide__courses {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  align-content: start;
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
}

/* 3–4 courses: pack two per row to stay within card max height */
.home-schedule-slide__courses--split {
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

/* 5+ courses: two columns + tighter course blocks */
.home-schedule-slide__courses--dense {
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.home-schedule-slide__courses--dense .home-schedule-course {
  padding: 10px 2px;
  gap: 10px;
}

.home-schedule-slide__courses--dense .home-schedule-course__title {
  font-size: 15px;
}

.home-schedule-slide__courses--dense .home-schedule-course__day {
  min-width: 1.85rem;
  padding: 3px 6px;
  font-size: 10.5px;
}

.home-schedule-slide__courses--dense .home-schedule-course__clock {
  font-size: 12.5px;
}

.home-schedule-slide__courses--dense .home-schedule-course__chip {
  padding: 2px 7px;
  font-size: 10.5px;
}

.home-schedule-slide__courses::-webkit-scrollbar {
  width: 4px;
}

.home-schedule-slide__courses::-webkit-scrollbar-thumb {
  background: #d5d1e0;
  border-radius: 999px;
}

.home-schedule-course {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(140px, 0.9fr);
  gap: 12px 18px;
  align-items: center;
  padding: 14px 2px;
  border: none;
  border-bottom: 1px solid #efeaf3;
  border-radius: 0;
  background: transparent;
  min-width: 0;
}

.home-schedule-course:last-child {
  border-bottom: none;
  padding-bottom: 2px;
}

.home-schedule-course:first-child {
  padding-top: 2px;
}

.home-schedule-course__main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.home-schedule-course__title {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #1f1b2e;
  line-height: 1.25;
}

.home-schedule-course__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.home-schedule-course__chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f1eff5;
  color: #6f6980;
  font-size: 11px;
  font-weight: 600;
}

.home-schedule-course__chip--year {
  background: #f1eff5;
  color: #6f6980;
}

.home-schedule-course__schedule {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 0;
}

.home-schedule-course__slot {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.home-schedule-course__days {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
}

.home-schedule-course__day {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.15rem;
  padding: 4px 7px;
  border-radius: 999px;
  background: #bff1db;
  color: #2f5c48;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1.15;
}

.home-schedule-course__clock {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #1f1b2e;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.home-schedule-course__clock i {
  font-size: 0.78rem;
  color: #7b72c8;
}

.home-schedule-course__time-empty {
  color: #8a849c;
  font-size: 13px;
  font-weight: 600;
}

@media (max-width: 560px) {
  .home-schedule-course {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .home-schedule-course__schedule,
  .home-schedule-course__slot,
  .home-schedule-course__days {
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.student-schedule__track.home-schedule-carousel {
  position: relative;
  padding: 0;
}

.student-schedule__track.home-schedule-carousel .slick-slider {
  position: relative;
  padding: 0;
  box-sizing: border-box;
}

/* Bottom control row: prev | dots | next
   (element is also .slick-dots — override slick absolute/block defaults) */
.home-schedule-carousel .home-schedule-controls,
.home-schedule-carousel .slick-dots.home-schedule-controls {
  position: static !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: 100% !important;
  height: auto !important;
  bottom: auto !important;
  margin: 1.15rem 0 0 !important;
  padding: 0 !important;
  list-style: none;
}

.home-schedule-carousel .home-schedule-arrow {
  position: static !important;
  display: grid !important;
  place-items: center;
  flex: 0 0 auto;
  width: 2.4rem;
  height: 2.4rem;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(31, 27, 46, 0.14);
  border-radius: 999px;
  background: #ffffff !important;
  color: #1f1b2e;
  font-size: 0.85rem;
  line-height: 1;
  box-shadow: none;
  cursor: pointer;
  transform: none !important;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    opacity 0.2s ease;
}

.home-schedule-carousel .home-schedule-arrow:hover:not(:disabled) {
  background: var(--sh-mint, #bff1db) !important;
  border-color: #8fd9b8;
  color: #1f1b2e;
}

.home-schedule-carousel .home-schedule-arrow:focus-visible {
  outline: 2px solid #1f1b2e;
  outline-offset: 2px;
}

.home-schedule-carousel .home-schedule-arrow:disabled {
  opacity: 0.28;
  cursor: default;
}

/* Hide default slick arrows if any remain */
.home-schedule-carousel .slick-prev,
.home-schedule-carousel .slick-next {
  display: none !important;
}

/* Nav dots */
.home-schedule-carousel ul.slick-dots,
.home-schedule-carousel ul.home-schedule-dots {
  position: static !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  bottom: auto !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  list-style: none !important;
}

@media (max-width: 700px) {
  .home-schedule-carousel .home-schedule-controls {
    gap: 0.75rem;
  }

  .home-schedule-carousel .home-schedule-arrow {
    width: 2.2rem;
    height: 2.2rem;
    font-size: 0.8rem;
  }
}

.home-schedule-carousel ul.slick-dots li,
.home-schedule-carousel ul.home-schedule-dots li {
  position: relative;
  display: block !important;
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  cursor: pointer;
}

.home-schedule-carousel ul.slick-dots li button,
.home-schedule-carousel ul.home-schedule-dots li button {
  display: none !important;
}

.home-schedule-carousel .home-schedule-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #c8c2d8;
  transition: width 0.2s ease, background 0.2s ease;
}

.home-schedule-carousel ul.slick-dots li.slick-active .home-schedule-dot,
.home-schedule-carousel ul.home-schedule-dots li.slick-active .home-schedule-dot {
  width: 22px;
  background: #403b55;
}

.home-schedule-carousel__loading {
  padding: 3vh 17vw;
  font-weight: 600;
  color: #625d75;
}

@media (max-width: 800px) {
  .home-schedule-carousel:not(.student-schedule__track) {
    padding: 4vh clamp(1.25rem, 6vw, 2rem) 2vh;
  }

  .home-schedule-carousel__loading {
    padding: 3vh clamp(1.25rem, 6vw, 2rem);
  }

  .home-schedule-slide__panel {
    max-height: 80vh;
    padding: 18px;
  }

  .home-schedule-slide__name {
    font-size: 1.05rem;
  }

  /* On single-card mobile width, keep one course column for readability */
  .home-schedule-slide__courses--split,
  .home-schedule-slide__courses--dense {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomeCarousel.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,sBAAsB;EACtB,uDAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,qFAAqF;AACrF;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iEAAiE;AACjE;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA,oDAAoD;AACpD;EACE,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;;IAGE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;2EAC2E;AAC3E;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,cAAc;EACd,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B;;;;qBAImB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;;EAEE,wBAAwB;AAC1B;;AAEA,aAAa;AACb;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA,wEAAwE;EACxE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".home-schedule-carousel:not(.student-schedule__track) {\n  padding: 5vh 17vw 2vh;\n  max-width: 100%;\n}\n\n/* Student landing: carousel sits inside the schedule section track */\n.student-schedule__track .slick-list {\n  margin: 0 -6px;\n  padding: 8px 0 6px;\n}\n\n.student-schedule__track .slick-slide {\n  padding: 0 0 10px;\n  box-sizing: border-box;\n}\n\n.home-schedule-carousel .slick-list {\n  margin: 0 -12px;\n  padding: 6px 0 4px;\n}\n\n.home-schedule-carousel .slick-track {\n  display: flex !important;\n  align-items: stretch;\n}\n\n.home-schedule-carousel .slick-slide {\n  height: auto;\n  display: flex;\n}\n\n.home-schedule-carousel .slick-slide > div {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.home-schedule-slide {\n  outline: none;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: 0 12px 8px;\n  box-sizing: border-box;\n}\n\n.home-schedule-slide__panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  max-height: 80vh;\n  padding: 22px;\n  border-radius: 22px;\n  background: #ffffff;\n  border: 1px solid #eceaf1;\n  box-shadow: 0 8px 24px rgba(48, 45, 69, 0.08);\n  box-sizing: border-box;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n  overflow: hidden;\n}\n\n.home-schedule-slide:hover .home-schedule-slide__panel {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 30px rgba(48, 45, 69, 0.12);\n}\n\n.home-schedule-slide__header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #f0edf4;\n  flex-shrink: 0;\n}\n\n/* Size/shape come from TeacherPhoto (.teacher-photo--circle); keep hook for layout */\n.home-schedule-slide__photo {\n  flex-shrink: 0;\n}\n\n.home-schedule-slide__identity {\n  min-width: 0;\n}\n\n.home-schedule-slide__name {\n  margin: 0;\n  font-size: clamp(1.05rem, 2.2vw, 1.25rem);\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #1f1b2e;\n  line-height: 1.2;\n}\n\n.home-schedule-slide__courses {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  align-content: start;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-right: 2px;\n}\n\n/* 3–4 courses: pack two per row to stay within card max height */\n.home-schedule-slide__courses--split {\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n/* 5+ courses: two columns + tighter course blocks */\n.home-schedule-slide__courses--dense {\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.home-schedule-slide__courses--dense .home-schedule-course {\n  padding: 10px 2px;\n  gap: 10px;\n}\n\n.home-schedule-slide__courses--dense .home-schedule-course__title {\n  font-size: 15px;\n}\n\n.home-schedule-slide__courses--dense .home-schedule-course__day {\n  min-width: 1.85rem;\n  padding: 3px 6px;\n  font-size: 10.5px;\n}\n\n.home-schedule-slide__courses--dense .home-schedule-course__clock {\n  font-size: 12.5px;\n}\n\n.home-schedule-slide__courses--dense .home-schedule-course__chip {\n  padding: 2px 7px;\n  font-size: 10.5px;\n}\n\n.home-schedule-slide__courses::-webkit-scrollbar {\n  width: 4px;\n}\n\n.home-schedule-slide__courses::-webkit-scrollbar-thumb {\n  background: #d5d1e0;\n  border-radius: 999px;\n}\n\n.home-schedule-course {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) minmax(140px, 0.9fr);\n  gap: 12px 18px;\n  align-items: center;\n  padding: 14px 2px;\n  border: none;\n  border-bottom: 1px solid #efeaf3;\n  border-radius: 0;\n  background: transparent;\n  min-width: 0;\n}\n\n.home-schedule-course:last-child {\n  border-bottom: none;\n  padding-bottom: 2px;\n}\n\n.home-schedule-course:first-child {\n  padding-top: 2px;\n}\n\n.home-schedule-course__main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.home-schedule-course__title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 800;\n  color: #1f1b2e;\n  line-height: 1.25;\n}\n\n.home-schedule-course__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.home-schedule-course__chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #f1eff5;\n  color: #6f6980;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.home-schedule-course__chip--year {\n  background: #f1eff5;\n  color: #6f6980;\n}\n\n.home-schedule-course__schedule {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  min-width: 0;\n}\n\n.home-schedule-course__slot {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.home-schedule-course__days {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.home-schedule-course__day {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.15rem;\n  padding: 4px 7px;\n  border-radius: 999px;\n  background: #bff1db;\n  color: #2f5c48;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  line-height: 1.15;\n}\n\n.home-schedule-course__clock {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #1f1b2e;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.home-schedule-course__clock i {\n  font-size: 0.78rem;\n  color: #7b72c8;\n}\n\n.home-schedule-course__time-empty {\n  color: #8a849c;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n@media (max-width: 560px) {\n  .home-schedule-course {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .home-schedule-course__schedule,\n  .home-schedule-course__slot,\n  .home-schedule-course__days {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n}\n\n.student-schedule__track.home-schedule-carousel {\n  position: relative;\n  padding: 0;\n}\n\n.student-schedule__track.home-schedule-carousel .slick-slider {\n  position: relative;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Bottom control row: prev | dots | next\n   (element is also .slick-dots — override slick absolute/block defaults) */\n.home-schedule-carousel .home-schedule-controls,\n.home-schedule-carousel .slick-dots.home-schedule-controls {\n  position: static !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  width: 100% !important;\n  height: auto !important;\n  bottom: auto !important;\n  margin: 1.15rem 0 0 !important;\n  padding: 0 !important;\n  list-style: none;\n}\n\n.home-schedule-carousel .home-schedule-arrow {\n  position: static !important;\n  display: grid !important;\n  place-items: center;\n  flex: 0 0 auto;\n  width: 2.4rem;\n  height: 2.4rem;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(31, 27, 46, 0.14);\n  border-radius: 999px;\n  background: #ffffff !important;\n  color: #1f1b2e;\n  font-size: 0.85rem;\n  line-height: 1;\n  box-shadow: none;\n  cursor: pointer;\n  transform: none !important;\n  transition:\n    background-color 0.2s ease,\n    border-color 0.2s ease,\n    color 0.2s ease,\n    opacity 0.2s ease;\n}\n\n.home-schedule-carousel .home-schedule-arrow:hover:not(:disabled) {\n  background: var(--sh-mint, #bff1db) !important;\n  border-color: #8fd9b8;\n  color: #1f1b2e;\n}\n\n.home-schedule-carousel .home-schedule-arrow:focus-visible {\n  outline: 2px solid #1f1b2e;\n  outline-offset: 2px;\n}\n\n.home-schedule-carousel .home-schedule-arrow:disabled {\n  opacity: 0.28;\n  cursor: default;\n}\n\n/* Hide default slick arrows if any remain */\n.home-schedule-carousel .slick-prev,\n.home-schedule-carousel .slick-next {\n  display: none !important;\n}\n\n/* Nav dots */\n.home-schedule-carousel ul.slick-dots,\n.home-schedule-carousel ul.home-schedule-dots {\n  position: static !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  bottom: auto !important;\n  width: auto !important;\n  height: auto !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  list-style: none !important;\n}\n\n@media (max-width: 700px) {\n  .home-schedule-carousel .home-schedule-controls {\n    gap: 0.75rem;\n  }\n\n  .home-schedule-carousel .home-schedule-arrow {\n    width: 2.2rem;\n    height: 2.2rem;\n    font-size: 0.8rem;\n  }\n}\n\n.home-schedule-carousel ul.slick-dots li,\n.home-schedule-carousel ul.home-schedule-dots li {\n  position: relative;\n  display: block !important;\n  width: auto !important;\n  height: auto !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  cursor: pointer;\n}\n\n.home-schedule-carousel ul.slick-dots li button,\n.home-schedule-carousel ul.home-schedule-dots li button {\n  display: none !important;\n}\n\n.home-schedule-carousel .home-schedule-dot {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #c8c2d8;\n  transition: width 0.2s ease, background 0.2s ease;\n}\n\n.home-schedule-carousel ul.slick-dots li.slick-active .home-schedule-dot,\n.home-schedule-carousel ul.home-schedule-dots li.slick-active .home-schedule-dot {\n  width: 22px;\n  background: #403b55;\n}\n\n.home-schedule-carousel__loading {\n  padding: 3vh 17vw;\n  font-weight: 600;\n  color: #625d75;\n}\n\n@media (max-width: 800px) {\n  .home-schedule-carousel:not(.student-schedule__track) {\n    padding: 4vh clamp(1.25rem, 6vw, 2rem) 2vh;\n  }\n\n  .home-schedule-carousel__loading {\n    padding: 3vh clamp(1.25rem, 6vw, 2rem);\n  }\n\n  .home-schedule-slide__panel {\n    max-height: 80vh;\n    padding: 18px;\n  }\n\n  .home-schedule-slide__name {\n    font-size: 1.05rem;\n  }\n\n  /* On single-card mobile width, keep one course column for readability */\n  .home-schedule-slide__courses--split,\n  .home-schedule-slide__courses--dense {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
